export default "__VITE_ASSET__BkVI49kk__"